<template>
  <header>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <div class="logo" style="padding-top: 7px;">
            <img src="/img/logo.png" alt="logo">
          </div>
        </div>
        <div class="col-md-6">
          <ul>
            <li>
              <a href="#" @click.stop="toggleDropdown">{{$store.state.userData.name}} 
                <img v-if="$store.state.userData.image" :src="$store.state.userData.image" style="max-width: 60px;height: 45px;" alt="Male_User">
                <img v-else src="/img/Male_User.png" alt="Male_User">
              </a>

              <div v-if="isOpen" @click.stop class="menu-drop right-0 w-48 mt-2 bg-white border border-gray-200 rounded-lg shadow-lg z-10">
                <router-link to="/brand/profile" class="dropdown-item">Personal Profile </router-link>
                <router-link to="/brand/details" class="dropdown-item">Brand Profile </router-link>
                <!-- <router-link to="/brand/payment-history?tab=subscription" class="dropdown-item">Billing </router-link> -->

                <!-- <a class="dropdown-item" data-toggle="modal" data-target="#switch-brand-popup" href="javascript:;">Switch Brand</a> -->
                <!-- <a class="dropdown-item" data-toggle="modal" data-target="#brandpopup">Setup New Brand</a> -->
                <a class="dropdown-item" @click="logout">Logout</a>
              </div>
            </li>
            <li v-if="brandInfo.logo != ''">
              <img :src="brandInfo.logo" style="max-width: 60px; height: 45px;" />
            </li>
          </ul>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      isOpen: false,
      brandInfo: {
        name: "",
        logo: "",
      },
    };
  },
  methods: {
    logout () {
      let sadmin = this.$store.state.loginAsBrand
      let brandId = this.$store.state.userData.brandId

      this.$store.dispatch('logoutAsBrand').then(() => {
        if (sadmin) {
          this.$router.push(`/sadmin/brands/${brandId}`)
        } else {
          this.$router.push('/brand/login')
        }
      })
    },
    getBrandDetails() {
      this.$store
        .dispatch("getBrandDetails", {
          brand_id: this.$store.state.userData.brandId,
        })
        .then((response) => {
          this.brandInfo = response.response.data;
          //console.log(this.brandInfo);
        })
        .catch(() => {});
    },
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    closeDropdown() {
      this.isOpen = false;
    },
  },
  mounted() {
    window.addEventListener("click", this.closeDropdown);
    this.getBrandDetails();
  },
  beforeUnmount() {
    window.removeEventListener("click", this.closeDropdown);
  },
};
</script>

<style>
.logo img{
    width: 160px;
}
header {
    padding: 10px 0;
    box-shadow: 1px 1px 4px rgba(0, 0, 0, 0.4);
}
header .col-md-6 ul {
    float: right;
    margin-bottom: 0px;
    padding: 3.5px 0;
}
header .col-md-6 li {
    display: inline;
    margin-left: 12px;
}
header .col-md-6 ul li a {
    color: #000;
    text-decoration: none;
    font-family: "Poppins", serif;
}
</style>

